import { FleetPermission, Role } from '@gm-commercial/profile-model';

import { RouteName } from '~/common/models/route.model';
import { lazyWithReload } from '~/common/utils/lazyWithReload';

const FleetList = lazyWithReload(
  () => import('~/features/fleets/list/FleetList')
);
const FleetDetails = lazyWithReload(
  () => import('~/features/fleets/details/FleetDetails')
);

const ORGANIZATIONS_FLEETS_ROUTES = {
  [RouteName.ORGANIZATIONS_FLEETS]: {
    name: RouteName.ORGANIZATIONS_FLEETS,
    path: [
      '/organizations/:organizationsId/fleets',
      '/organizations/:organizationsId/hubs/:hubsId/fleets',
    ],
    authorizedPerms: [FleetPermission.READ],
    excludedRoles: [Role.FLEET_MANAGER, Role.OPERATOR],
    element: FleetList,
  },
  [RouteName.ORGANIZATIONS_FLEETS_DETAILS]: {
    name: RouteName.ORGANIZATIONS_FLEETS_DETAILS,
    path: [
      '/organizations/:organizationsId/fleets/:fleetsId',
      '/organizations/:organizationsId/hubs/:hubsId/fleets/:fleetsId',
    ],
    authorizedPerms: [FleetPermission.READ],
    excludedRoles: [Role.OPERATOR],
    element: FleetDetails,
  },
};

export default ORGANIZATIONS_FLEETS_ROUTES;
